export default function HunterSection() {
  return (
    <section id="hunter" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-primary-700 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
          <i className="ri-user-star-line"></i>
          女猟師としての活動
        </p>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug">
          止め刺しから精肉まで、
          <br />
          一人で。
        </h2>
        <p className="mt-6 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
          猟師さんから連絡が来ると、必ず私が現地へ向かい、止め刺し・血抜きを行います。
          捕獲された<strong>猪</strong>を、ただ商品にするのではなく、
          一頭一頭と向き合い、命をいただく。
        </p>
        <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
          止め刺しから精肉まで、すべて一人で行っているため、
          ご連絡や発送が遅れる場合があります。
          それでも、命を無駄にしないための、私たちのやり方です。
        </p>
      </div>
    </section>
  );
}